import clsx from 'clsx';
import { useAppearance } from '@/hooks';

export const AppearanceToggle = () => {
	const { isDark, toggleAppearance } = useAppearance();

	return (
		<div className="notifications">
			<h2 className="section-title">Tema</h2>
			<div className="notification-item">
				<span className="notification-text">Koyu temayı kullanın</span>
				<button
					className={clsx('toggle-switch', {
						off: !isDark
					})}
					onClick={toggleAppearance}
					aria-label="Koyu tema"
					aria-pressed={isDark}
				/>
			</div>
		</div>
	);
};
